import { Heading as Base, HEADINGS } from "@corca/tiptap";

import { LineWrapperView } from "@/components/tiptap/utils/LineWrapperView";

export { HEADINGS };

export const Heading = Base.extend({
  addNodeView() {
    return (props) => {
      return new LineWrapperView(props, {
        renderNodeAsChildIn: [
          "blockquote",
          "callout",
          "listItem",
          "taskItem",
          "tableCell",
          "tableHeader",
        ],
        className: "mt-7.5 mb-2.5",
      });
    };
  },
});
